"use strict";

var _interopRequireDefault = require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regenerator2 = _interopRequireDefault(require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/regenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/createClass.js"));
var _vue = _interopRequireDefault(require("vue"));
var _dictDetail = require("@/api/system/dictDetail");
var Dict = exports.default = /*#__PURE__*/function () {
  function Dict(dict) {
    (0, _classCallCheck2.default)(this, Dict);
    this.dict = dict;
  }
  return (0, _createClass2.default)(Dict, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(names, completeCallback) {
        var _this = this;
        var ps;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(names === undefined || name === null)) {
                _context.n = 1;
                break;
              }
              throw new Error('need Dict names');
            case 1:
              ps = [];
              names.forEach(function (n) {
                _vue.default.set(_this.dict.dict, n, {});
                _vue.default.set(_this.dict.label, n, {});
                _vue.default.set(_this.dict, n, []);
                ps.push((0, _dictDetail.get)(n).then(function (data) {
                  var _this$dict$n;
                  (_this$dict$n = _this.dict[n]).splice.apply(_this$dict$n, [0, 0].concat((0, _toConsumableArray2.default)(data.content)));
                  data.content.forEach(function (d) {
                    if (parseInt(d.value).toString() != 'NaN') {
                      d.value = parseInt(d.value);
                    }
                    _vue.default.set(_this.dict.dict[n], d.value, d);
                    _vue.default.set(_this.dict.label[n], d.value, d.label);
                  });
                }));
              });
              _context.n = 2;
              return Promise.all(ps);
            case 2:
              completeCallback();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }]);
}();